<template>
  <section>
    <h2 class="h2Title">화상회의 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="화상회의 생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>

              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn color="primary" class="vBtn vIconResize mgr" @click="createForm" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                회의실 개설
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="datasets"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="roomId"
            class="elevation-1"
            disable-sort
        >
          <template v-slot:item.roomId="{ item }">
            <a @click="join(item)" v-if="item.roomState === 'STATE_OPENED'"> {{item.roomId}} </a>
            <span v-else> {{item.roomId}} </span>
          </template>
          <template v-slot:item.copyUrl="{ item }">
            <v-btn class="vBtn" color="success" @click="copyUrl(item.roomId)" depressed small :disabled="item.roomState !== 'STATE_OPENED'" :dark="item.roomState === 'STATE_OPENED'">
              <v-icon small>mdi mdi-clipboard-outline</v-icon>
              복사
            </v-btn>
          </template>
          <template v-slot:item.roomState="{ value }">
            {{ value === 'STATE_OPENED' ? '회의중' : '종료' }}
          </template>
          <template v-slot:item.hasPassword="{ value }">
            {{ value === true ? '비공개' : '공개' }}
          </template>
          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY.MM.DD HH:mm') }}
          </template>

          <template v-slot:item.createdBy="{ item }">
            {{ item.createdByName }} ( {{ item.createdBy }} )
          </template>

          <template v-slot:item.actions="{ item }">
<!--            <v-icon-->
<!--                small-->
<!--                class="mr-2"-->
<!--                @click="updateForm(item)"-->
<!--            >-->
<!--              mdi-pencil-->
<!--            </v-icon>-->
            <v-icon
                v-if="item.roomState === 'STATE_OPENED'"
                small
                @click="inviteForm(item.roomId)"
            >
              mdi-account-plus
            </v-icon>
            <v-icon
                small
                @click="deleteHypermeeting(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </article>

    <v-dialog v-model="formDialog" max-width="500px" @click:outside="formDialog = false" @keydown.esc="formDialog = false">
      <v-card>
        <v-card-title class="headline">회의실 개설</v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="formHypermeeting">

              <v-col>
                <v-text-field label="제목입력" dense solo flat outlined clearable v-model="room.roomName" :rules="[rules.required]"/>
              </v-col>

              <v-col>
                <v-switch
                    v-model="room.hasPassword"
                    flat
                    class="custom-red"
                    :label="!room.hasPassword ? '공개' : '비공개'"
                ></v-switch>
              </v-col>

              <v-col v-if="room.hasPassword">
                <v-text-field label="비밀번호" dense solo flat outlined clearable v-model="room.roomPassword"
                              :type="passwordShow ? 'text' : 'password'"
                              :append-icon="passwordShow? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="passwordShow = !passwordShow"
                              :rules="[rules.required]"
                />
              </v-col>

            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="formDialog = false">창닫기</v-btn>
          <v-btn color="primary" dark @click="save">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="userDialog" max-width="1200px" @click:outside="userDialog = false" @keydown.esc="userDialog = false">
        <invite v-bind:room-id="roomId" @callback-close="inviteClose"></invite>
    </v-dialog>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";
import Invite from "@/views/hypermeeting/dialog/Invite";
import hypermeetingApi from '@/api/HypermeetingApi'
// import _ from "lodash";

export default {
  name: "Hypermeeting",
  components: {
    'date-range-component': DateRageComponent,
    Invite
  },
  data: () => ({
    room: {},
    roomId: null,
    passwordShow: false,
    formDialog: false,
    userDialog: false,
    staticPath: process.env.VUE_APP_ATTACH_STATIC_PATH,
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    activeItem: null,
    selected: [],
    headers: [
      {text: '회의실 아이디', value: 'roomId', align: 'left'},
      {text: '회의실 주소 복사', value: 'copyUrl', align: 'center'},
      {text: '제목', value: 'roomName', align: 'center'},
      {text: '상태', value: 'roomState', align: 'center'},
      {text: '공개여부', value: 'hasPassword', align: 'center'},
      {text: '리더', value: 'createdBy', align: 'center'},
      {text: '생성일', value: 'createdAt', align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    param: {
      searchDate:[],
      searchKeyword: null,
      page: 1
    },
    datasets: [],
    totalItems: 0,
    dialogVisible: false,
    waitingSearch: false,
    options:{}
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  methods: {
    copyUrl(roomId){
      let url = `${process.env.VUE_APP_HYPER_MEETING}/meeting/${roomId}`
      this.$copyText(url);
      alert('회의실 주소가 복사되었습니다.')
    },
    join(item) {
      let roomUrl = `${process.env.VUE_APP_HYPER_MEETING}/meeting/${item.roomId}?userId=${this.$store.state.user.userid}&userName=${this.$store.state.user.username}`
      if(item.createdBy === this.$store.state.user.userid)
          roomUrl += `&leaderKey=${item.leaderKey}`
      if(item.hasPassword)
          roomUrl += `&password=${item.roomPassword}`
      window.open(roomUrl, '_new');
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    search() {
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};

      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      hypermeetingApi.list(params).then(data => {
        this.datasets = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params);
      });
    },
    createForm() {
      this.formDialog = true;
      this.$refs.formHypermeeting?.resetValidation();
      this.room = {};
      // this.$router.push({path: `/hypermeeting/form`})
    },
    inviteForm(roomId) {
      this.userDialog = true;
      this.roomId = roomId;
    },
    inviteClose() {
      this.userDialog=false;
      this.roomId = null;
    },
    async save() {
      if(!await this.$refs.formHypermeeting.validate())
        return;

      hypermeetingApi.save(this.room).then(data => {
        alert("회의실이 개설 되었습니다.")
        console.log(data);
        // if(confirm('회의실이 개설 되었습니다.\n회의실에 입장하시겠습니까?')) {
        //   setTimeout(() => {
        //     window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${data.roomId}?userId=${this.$store.state.user.userid}&userName=${this.$store.state.user.username}&leaderKey=${data.leaderKey}`, '_new');
        //   }, 1000);
        // }
        this.formDialog = false;
        this.search();
      });

    },
    // updateForm(item) {
    //   this.$router.push({path:`/hypermeeting/form/${item.roomId}`});
    // },
    deleteHypermeeting(item) {
      if(confirm('회의실 개설 내역을 삭제하시겠습니까?')) {
        hypermeetingApi.deleteRoom(item.roomId).then(() => {
          this.search();
        });
      }
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
